// src/components/PropertiesList.jsx

import React from 'react';
import { useIntl } from 'react-intl';

// Adicionando a prop `emptyListMessage` para customização
export default function PropertiesList({ properties, loading, error, emptyListMessage }) {
  const intl = useIntl();

  if (loading) {
    return (
      <div className="progress-container" style={{ minHeight: '100px', justifyContent: 'flex-start', alignItems: 'center', display: 'flex', gap: '1rem' }}>
        <div className="spinner"></div>
        <p className="progress-text" style={{ margin: 0 }}>{intl.formatMessage({ id: 'loading', defaultMessage: 'Carregando...' })}</p>
      </div>
    );
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (!properties || properties.length === 0) {
    // Usa a mensagem customizada se fornecida, senão usa o padrão.
    return <p className="property-list-empty">{emptyListMessage || intl.formatMessage({ id: 'properties.noProperties', defaultMessage: 'Nenhum imóvel cadastrado ainda.' })}</p>;
  }

  return (
    <div className="user-card-grid">
      {properties.map((p) => {
        // Harmoniza os campos de dados para serem compatíveis com ambos os fluxos (Firestore e preview)
        const propertyType = p.property_type || p.tipo || 'Imóvel';
        const city = p.address?.city || p.cidade || 'Cidade não informada';
        const price = p.price || p.preco;
        // Prioriza a descrição da IA, mas usa a descrição normal como fallback
        const description = p.descricao_ia || p.descricao;

        return (
          <div key={p.id} className="user-card">
            <div className="user-card-info">
              <h4>{propertyType.charAt(0).toUpperCase() + propertyType.slice(1)}</h4>
              <p className="text-sm">
                {p.bairro ? `${p.bairro}, ${city}` : city}
              </p>
              {description && <p className="text-sm" style={{ fontStyle: 'italic', color: '#555', marginTop: '8px' }}>{description}</p>}
              <p style={{ marginTop: '12px' }}>
                <strong>{intl.formatMessage({ id: 'csvUpload.price' })}:</strong>{' '}
                {price?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || 'N/A'}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
